import { ComponentProps } from 'react';
import { IntercomProvider } from 'react-use-intercom';

export function MaybeIntercomProvider({
  appId,
  ...props
}: Partial<ComponentProps<typeof IntercomProvider>>) {
  if (!appId) {
    return props.children;
  }

  return <IntercomProvider appId={appId} {...props} />;
}
